mutation PurchaseOrderApprovalRevision(
  $input: PurchaseOrderApprovalRevisionInput!
) {
  purchaseOrderApprovalRevision(input: $input) {
    clientMutationId
    revisedApprovalEntity
  }
}
